import { createTheme } from "@mui/material/styles";
import { red, common } from "@mui/material/colors";
import { buttonClasses } from "@mui/material/Button";

const primaryColor = "#1A1A1D";
// #C3073F

export const theme = createTheme({
  palette: {
    primary: {
      main: primaryColor,
      light: common.white,
    },
    secondary: {
      main: "#C3073F",
      light: "#950740",
    },
    light: {
      main: "#FFFFFF",
    },
    error: {
      main: red.A400,
    },
    background: {
      default: "#F5F5F5",
      paper: "#E5E5E5",
      // paper: common.white
    },
    grey: {
      600: "#F1F1F1",
      700: "#F3F4F6",
      800: "#77633B",
      900: "#ADADAD",
    },
  },
  typography: {
    fontFamily: "Poppins",
    fontSize: 16,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
  },
  components: {
    // Name of the component
    MuiButton: {
      styleOverrides: {
        // Name of the slot
        root: {
          fontSize: "0.8rem",
          fontFamily: "Poppins",
          borderRadius: 0,
          boxShadow: "none",
          textTransform: "none",
          padding: "6px 12px",
          letterSpacing: "0.05em",
          // color: common.white,
          ":hover": {
            backgroundColor: primaryColor,
            color: "#fff",
          },
          ":active": {
            backgroundColor: primaryColor,
            color: primaryColor,
          },
          transition: "0.32s ease-out",
          // ...{
          //   [`&.${buttonClasses.textPrimary}`]: {
          //     color: common.white + ' !important'
          //   }
          // },
          ...{
            [`&.${buttonClasses.outlined}`]: {
              color: "#fff",
            },
          },
          ...{
            [`&.${buttonClasses.outlined}:hover`]: {
              backgroundColor: "transparent",
              borderColor: "#C3073F",
            },
          },
          ...{
            [`&.${buttonClasses.outlined}:active`]: {
              backgroundColor: "#F1F1F1",
              borderColor: "#F1F1F1",
            },
          },
          ...{
            [`&.${buttonClasses.outlinedSecondary}`]: {
              backgroundColor: "#C3073F",
              borderColor: "#C3073F",
              color: primaryColor,
            },
          },
          ...{
            [`&.${buttonClasses.outlinedSecondary}:hover`]: {
              backgroundColor: "transparent",
              color: primaryColor,
              borderColor: "#C3073F",
            },
          },
          ...{
            [`&.${buttonClasses.outlinedSecondary}:active`]: {
              backgroundColor: "transparent",
              color: primaryColor,
              borderColor: "#C3073F",
            },
          },
        },
      },
      defaultProps: {
        // disableRipple: true
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF",
          boxShadow: "0px 10px 16px 0px rgba(154, 154, 154, 0.13)",
        },
      },
      defaultProps: {
        square: true,
      },
    },
    MuiTypography: {
      styleOverrides: {
        h1: {
          fontSize: "1.8rem",
          fontFamily: "Poppins",
          color: primaryColor,
          fontWeight: 800,
        },
        h2: {
          fontSize: "1.4rem",
          fontFamily: "Poppins",
          color: primaryColor,
          fontWeight: 700,
        },
        h3: {
          fontSize: "1.2rem",
          fontFamily: "Poppins",
          color: primaryColor,
          fontWeight: 600,
        },
        // h4: {
        //   fontSize: "1rem",
        //   fontFamily: "Poppins",
        //   color: primaryColor,
        //   fontWeight: 600,
        // },
        caption: {
          fontFamily: "Inter",
          fontSize: "1rem",
          textTransform: "uppercase",
        },
        subtitle: {
          fontSize: "1rem",
          fontFamily: "Inter",
          fontStyle: "italic",
          // color: '#6F6F6F',
        },

        body: {
          fontSize: "1rem",
          fontFamily: "Inter",
          // color: '#717171'
        },
      },
      defaultProps: {
        color: primaryColor,
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          cursor: "pointer",
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: common.white,
          boxShadow: "0px 4px 15px rgba(221, 221, 221, 0.25)",
          paddingBlock: 7,
        },
      },
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: common.white,
          opacity: 1,
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          fontSize: "0.8rem",
          lineHeight: 1.5,
        },
      },
    },
    MuiMenu: {
      styleOverrides: {
        root: {
          boxShadow: "0px 14px 14px rgba(185, 185, 185, 0.25)",
          borderRadius: "4px",
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        popper: {
          backgroundColor: "#ffffff",
          boxShadow: "0px 4px 4px rgba(211, 211, 211, 0.25)",
          borderRadius: "6px",
        },
      },
    },
    MuiCheckbox: {
      defaultProps: {
        size: "small",
      },
      styleOverrides: {
        root: {
          borderRadius: "6px",
        },
      },
    },
    MuiCard: {
      defaultProps: {
        raised: false,
        elevation: 0,
      },
      styleOverrides: {
        root: {
          boxShadow: "none",
        },
      },
    },

    // MuiTable: {
    //   styleOverrides: {
    //     root: {
    //       backgroundColor: common.white,
    //       boxShadow: '0px 4px 15px rgba(221, 221, 221, 0.25)',
    //       paddingBlock: 7,
    //       borderRadius: 0,
    //       border: 'none',
    //       '&:hover': {
    //         backgroundColor: common.white,
    //         boxShadow: '0px 4px 15px rgba(221, 221, 221, 0.25)',
    //         paddingBlock: 7,
    //         borderRadius: 0,
    //         border: 'none',
    //         display: 'table',
    //         width: '100%',
    //         height: '100%',
    //         cursor: 'pointer'
    //       }
    //     }
    //   }
    // },
    // MuiTableCell: {
    //   styleOverrides: {
    //     root: {
    //       padding: '0px',
    //       border: 'none',
    //       borderRadius: 0,
    //       backgroundColor: common.white,
    //       boxShadow: '0px 4px 15px rgba(221, 221, 221, 0.25)',
    //       '&:hover': {
    //         backgroundColor: common.white,
    //         boxShadow: '0px 4px 15px rgba(221, 221, 221, 0.25)',
    //         paddingBlock: 7,
    //         borderRadius: 0,
    //         border: 'none',
    //         display: 'table',
    //         width: '100%',
    //         height: '100%',
    //         cursor: 'pointer',
    //         '& $content': {
    //           color: primaryColor,
    //           fontWeight: 'bold',
    //           fontSize: '0.85rem',
    //           fontFamily: 'Avenir-Book',
    //           textTransform: 'uppercase',
    //           padding: '0px',
    //           border: 'none',
    //           borderRadius: 0,
    //           backgroundColor: common.white,
    //           boxShadow: '0px 4px 15px rgba(221, 221, 221, 0.25)'
    //         }
    //       }
    //     }
    //   }
    // }
  },
});
